<template>
  <v-card
    ma-0
    pa-0
  >
    <v-card-title class="pa-0 body-1">
      <v-toolbar flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <slot name="title" />
      </v-toolbar>
    </v-card-title>
    <v-divider
      color="white"
      class="ma-0"
    />
    <v-card-text
      :class="justify + ' align-start pa-2 body-2'"
      :style="contentStyle + ' overflow-y: auto;'"
    >
      <slot name="content" />
    </v-card-text>
    <v-card-actions
      v-if="hasFooter"
      :style="footerStyle"
    >
      <slot name="footer" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    contentHeight: {
      type: String,
      default: "65vh",
    },
    footerHeight: {
      type: String,
      default: "65px",
    },
    overflow: {
      type: String,
      default: "visible",
    },
    justify: {
      type: String,
      default: "justify-center",
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    contentStyle() {
      return "height: calc(" + this.contentHeight + " - " + this.footerHeight + "); overflow: " + this.overflow + ";";
    },
    footerStyle() {
      return "height: " + this.footerHeight + ";";
    },
  },
};
</script>

<style></style>
